// Requires: src/myProduct.js
// Requires: src/register-product.sectionManager.js
// Requires: src/register-product.serialErrorManager.js
// Requires: src/register-product.promoManager.js
// Requires: src/register-product.purchaseDate.js

(function($, myProduct, sectionManager, serialErrorManager, promoManager, purchaseDate) {
	'use strict';

	var CONST = {
		serialForm:         'data-serial-form',
		serialInput:        'data-serial-input',

		resultItem:         'data-result-item',
		resultItemName:     'data-result-item-name',
		resultItemSerial:   'data-result-item-serial',
		resultItemImage:    'data-result-item-image',
		resultItemDelete:   'data-result-item-delete',

		productList:        'data-product-list',
		productCardClone:   'data-product-card-clone',
		productCardID:      'data-product-id',
		productCardName:    'data-product-model-name',
		productCardSerial:  'data-product-model-serial',
		productCardImage:   'data-product-model-image',
		productCardModelID: 'data-product-model-id',

		notMyProduct:       'data-not-my-product',
		productReset:       'data-product-reset-stage',
		dataSourceId:       'data-source-item-id'
	};

	var REQUEST_URLS;

	// If Styleguide Environment
	if (window.envStyleguide) {
		REQUEST_URLS = '/_sg-client/example_data/products-';
	} else {
		REQUEST_URLS = {
			products:   '/api/sitecore/SerialNumber/Get'
		};
	}

	var Utility = {

		// Gets the element you need
		getDataElement: function(elName) {
			return $('[' + elName + ']');
		},

		setProductData: function (product, productData, dataAttributes) {

		    product.find('[' + dataAttributes.name + ']').eq(0).text(productData.model);

			if(productData.hasOwnProperty('productId')) {
			    product.find('[' + dataAttributes.serial + ']').eq(0).text(productData.serial);
			}

			product.find('['+ dataAttributes.image +']').eq(0).attr({
				src: productData.image,
				alt: productData.model + ' - ' + productData.serial
			});

			product.attr(dataAttributes.productID, productData.id);
		},

		getParameterByName: function (name, url) {
			if (!url) url = window.location.href;
			name = name.replace(/[\[\]]/g, "\\$&");
			var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			var queryString = decodeURIComponent(results[2].replace(/\+/g, " "));
			return queryString.substr(queryString.length - 9);
		}
	};

	var $serialForm   = Utility.getDataElement(CONST.serialForm).eq(0);
	var $serialInput  = Utility.getDataElement(CONST.serialInput).eq(0);

	var $productList  = Utility.getDataElement(CONST.productList).eq(0);
	var $productClone = $productList.find('['+ CONST.productCardClone +']').eq(0);
	var $resultItem   = Utility.getDataElement(CONST.resultItem).eq(0);
	var $productReset = Utility.getDataElement(CONST.productReset);

	var $notMyProduct = Utility.getDataElement(CONST.notMyProduct);

	var $dataSourceId = Utility.getDataElement(CONST.dataSourceId).eq(0);

	function handleRemoveEvent(event) {
		var productId;
		event.preventDefault();
		event.stopImmediatePropagation();
		productId = $(event.target).data('productId');

		if(productId) {
			myProduct.remove(productId);

			resetSteps();
		}
	}

	function displayError(message) {
		serialErrorManager.showError(message);
		// Reset the left side to the initial point
		sectionManager.reset(false, false);
	}

	function scrollTop() {
		if(window.innerWidth < 768) {
			$('html, body').animate({ scrollTop: 0 }, 300);
		}
	}

	function displayAddedProduct(productData) {

		var dataAttributes = {
			name:       CONST.resultItemName,
			serial:     CONST.resultItemSerial,
			image:      CONST.resultItemImage,
			productID:  CONST.resultItem
		};

		scrollTop();

		// Set the serial of the current product
		promoManager.reset();
		promoManager.setCurrent(productData.serial, productData.productId);

		Utility.setProductData($resultItem, productData, dataAttributes);
		purchaseDate.setFormVisibility(true);

		// Intro text control
		if(productData.hasPromo) {
			promoManager.setFormVisibility(true);
			purchaseDate.showDefaultPurchaseDateText(false);
			promoManager.showDefaultPurchaseDateText(true);
		} else {
			promoManager.setFormVisibility(false);
			purchaseDate.showDefaultPurchaseDateText(true);
			promoManager.showDefaultPurchaseDateText(false);
		}

		// Hide the loading screen
		sectionManager.hideSection(sectionManager.SECTIONS.loading);

		// Hide the form and the results stage.
		sectionManager.hideSection(sectionManager.SECTIONS.form);
		sectionManager.hideSection(sectionManager.SECTIONS.results);

		// Show the success and the product detail stages
		sectionManager.showSection(sectionManager.SECTIONS.success);
		sectionManager.showSection(sectionManager.SECTIONS.productDetail);

		// Add to the my products component
		purchaseDate.setProductData(productData);

		// This sets the attribute to the id so when the element is clicked it will check for the id and delete that product.
		$notMyProduct.attr(CONST.productCardID, productData.productId);

	}

	function handleSingleProductResult(resultData) {
	    displayAddedProduct(resultData);
	}

	function addProductHandler(event) {
		event.preventDefault();
		event.stopImmediatePropagation();
		var resultData = event.data.productData;

		handleSingleProductResult(resultData);
	}

	function displayMultipleProductOptions(products) {
		var newItem, dataAttributes;
		var items = [];

		// Loops through each object in the global data array.
		for(var i = 0; i < products.length; i++) {
			newItem = $productClone.clone();

			// Removes the attr because this is used to hide the element.
			newItem.removeAttr(CONST.productCardClone);

			dataAttributes = {
				name: CONST.productCardName,
				serial: CONST.productCardSerial,
				image: CONST.productCardImage,
				productID: CONST.productCardID
			};

			Utility.setProductData(newItem, products[i], dataAttributes);

			newItem.find('['+ CONST.productCardModelID +']').text(products[i].serial);

			// attach event to item so when you add the product to your list.
			newItem.on('click', { productData: products[i] }, addProductHandler);

			items.push(newItem);
		}

		return items;
	}

	function createProducts(productData) {
		// This will return an array of product elements.
		var products = displayMultipleProductOptions(productData);

		// Clear the previous products from the results list.
		$productList.empty();

		// Loops through each product and add it to the result list.
		$.each(products, function(i, item) {
			$productList.append(item);
		});
	}

	function handleEmptyProductResult(error) {
		// Hide the loading screen
		sectionManager.hideSection(sectionManager.SECTIONS.loading);

		// Set gif screen to display
		sectionManager.showSection(sectionManager.SECTIONS.gifScreen);

		// Hides this just incase youre searching from the results stage.
		sectionManager.hideSection(sectionManager.SECTIONS.results);

		// Display Error message
		displayError(error.message);
	}

	function handleMultipleProductResult(productsData) {

		// Hide the loading screen
		sectionManager.hideSection(sectionManager.SECTIONS.loading);

		// Set results screen to display
		sectionManager.showSection(sectionManager.SECTIONS.results);

		// Hide form err (if there was one)
		serialErrorManager.hideError();

		// Create products
		createProducts(productsData);

	}

	function handleProductRequest(responseData) {
		if(typeof responseData === 'object') {
			if(!responseData.error && responseData.hasOwnProperty('products')) {

				switch(responseData.products.length) {
					case 1:
						handleSingleProductResult(responseData.products[0]);
					break;
					case 0:
						handleEmptyProductResult(responseData.error);
					break;
					default:
						handleMultipleProductResult(responseData.products);
					break;
				}
			} else {
				displayError(responseData.error.message);
			}
		} else {
			displayError();
		}
	}

	function resetSteps() {
		// This function resets the stage positions and starts the process again.
		sectionManager.reset(true, false);

		serialErrorManager.hideError();
		$serialInput.val('');
		$serialInput.focus();
	}

	// Handler for click events that are used to reset the process.
	function handleResetEvent(event) {
		event.preventDefault();
		event.stopImmediatePropagation();
		resetSteps();
	}

	function handleSerialSubmit(event) {
		var requestData = {};
		event.preventDefault();
		event.stopImmediatePropagation();
		// Set Gif screen to hide
		sectionManager.hideSection(sectionManager.SECTIONS.gifScreen);

		// Show loading screen
		sectionManager.showSection(sectionManager.SECTIONS.loading);

		requestData.serial = $serialInput.val();
		requestData.dataSourceItemId = $dataSourceId.val();

		// DEV ENVIRONMENT
		// If Styleguide Environment
		if (window.envStyleguide) {
		var request_url = REQUEST_URLS;

		if(requestData.serial !== '0001' && requestData.serial !== '0002' && requestData.serial !== '0003' && requestData.serial !== '0004') {
			request_url += 'fail';
		} else {
			request_url += requestData.serial;
		}
		request_url += '.json';

		$.get(request_url)
			.done(handleProductRequest)
			.fail(function() {
				displayError();
			});

		// ELSE: LIVE ENVIRONMENT
		} else {

	  $.post(REQUEST_URLS.products, requestData)
			.done(handleProductRequest)
			.fail(function() {
				displayError();
			});

		} // end environment if
	}

	function bindEvents() {
		$notMyProduct.on('click', handleRemoveEvent);
		$productReset.on('click', handleResetEvent);

		$($serialForm).submit(handleSerialSubmit);
	}

	function promotionsCallback(gssg) {
	}

	if($serialForm.length > 0) {
		sectionManager.populateStages();
		serialErrorManager.init();
		promoManager.init(promotionsCallback);

		bindEvents();

		if (Utility.getParameterByName('sn') !== null && Utility.getParameterByName('sn').trim().length > 0) {
			if ($serialInput.val().trim().length <= 0) {
				$serialInput.val(Utility.getParameterByName('sn').trim());
				$serialForm.submit();
			}
		}
	}

})($jq, window.BOL.myProduct, window.BOL.RegisterProduct.sectionManager, window.BOL.RegisterProduct.serialErrorManager, window.BOL.RegisterProduct.promoManager, window.BOL.RegisterProduct.PurchaseDate);
